import { useSvcCrunchesContext } from '@dc-shared-web/providers'
import { useMutation } from 'react-query'
import {
  GetOriginalPdfParams,
  getOriginalPdf,
} from '@dc-shared-web/hooks/api/document/getOriginalPdf'

export const useGetOriginalPdf = () => {
  const svcCrunchApiClient = useSvcCrunchesContext()

  return useMutation((mutationParams: GetOriginalPdfParams) =>
    getOriginalPdf(svcCrunchApiClient, mutationParams)
  )
}
